import React from 'react';
import { formatYAxisNumber } from './ChartConstants';

interface CustomTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: string;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '18px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          minWidth: '180px',
          maxWidth: '280px',
        }}
      >
        <p style={{ margin: 0, fontWeight: 400, color: '#333', paddingBottom: '4px', }}>{label}</p>
        <div
          style={{
            borderTop: '1px solid #e0e0e0',
            margin: '8px 0',
          }}
        />
        {payload.map((entry: any, index: number) => (
          <p key={index} style={{ margin: '4px 0 0 0', paddingTop: '4px', color: entry.color || '#333', fontWeight: 600 }}>
            {formatYAxisNumber(entry.value)}
          </p>
        ))}
      </div>
    );
  }

  return null;
};